import { CalendarCheck, IndianRupee, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export const PricingCta = ({ onPrice, onVisit }) => (
  <section data-testid="pricing-cta-section" className="py-20 sm:py-28 bg-[#FFFFFF]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h2 className="font-serif-display text-3xl sm:text-4xl text-[#365314]">Vinayak 21 Acres Price</h2>
        <p className="mt-4 text-[#4D7C0F] text-sm sm:text-base leading-relaxed">
          Pricing and availability are subject to change and vary by configuration, tower, floor and unit selection.
          For the latest developer-provided pricing, see the{" "}
          <Link to="/vinayak-21-acres-price" className="text-[#65A30D] font-semibold hover:underline">Vinayak 21 Acres price</Link>{" "}
          page — or send us a quick enquiry below.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl bg-[#EAF5D6] p-8 sm:p-12 h-full hero-grain" data-testid="pricing-card">
            <IndianRupee size={28} className="text-[#84CC16]" strokeWidth={1.5} />
            <h3 className="font-serif-display text-3xl sm:text-4xl font-medium text-[#3F6212] mt-6 leading-tight">
              Get the latest price list &amp; payment plans
            </h3>
            <p className="text-[#4D7C0F] text-sm sm:text-base mt-4 leading-relaxed max-w-md">
              Pricing and availability are subject to change. Share your details and Forest Hill Realtors will send
              you the most current information for your preferred configuration.
            </p>
            <button
              data-testid="pricing-get-price-btn"
              onClick={onPrice}
              className="mt-8 bg-gradient-to-r from-[#84CC16] to-[#65A30D] text-[#365314] font-sub font-medium text-sm px-8 py-4 rounded-full hover:brightness-105 active:scale-[0.98] transition-all duration-300"
            >
              Get Latest Price &amp; Availability
            </button>
            <Link
              to="/vinayak-21-acres-price"
              data-testid="pricing-price-details-link"
              className="mt-5 inline-flex items-center gap-2 text-[#84CC16] text-sm font-sub font-medium hover:underline"
            >
              View Latest Price Details <ArrowRight size={14} />
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="relative overflow-hidden rounded-2xl border border-[#DCECC0] bg-[#F4FAE8] p-8 sm:p-12 h-full" data-testid="site-visit-card">
            <CalendarCheck size={28} className="text-[#365314]" strokeWidth={1.5} />
            <h3 className="font-serif-display text-3xl sm:text-4xl font-medium text-[#365314] mt-6 leading-tight">
              Walk the park before you decide
            </h3>
            <p className="text-[#4D7C0F] text-sm sm:text-base mt-4 leading-relaxed max-w-md">
              Book a guided site visit at a time that suits you. Experience the light, the ventilation and the 3-acre
              central park in person.
            </p>
            <button
              data-testid="pricing-book-visit-btn"
              onClick={onVisit}
              className="mt-8 bg-[#84CC16] text-[#365314] font-sub font-medium text-sm px-8 py-4 rounded-full hover:bg-[#9ADB3E] active:scale-[0.98] transition-all duration-300"
            >
              Book a Site Visit
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
